import { useNavigate } from 'react-router-dom'

import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import RenameAutomationModal from 'modules/automations/components/RenameAutomationModal'

import { useCurrentAutomationRoute } from './details/currentRoute'

const RenameAutomationModalPage = () => {
  const navigate = useNavigate()
  const { id } = useStrictParams<'id'>()

  const route = useCurrentAutomationRoute()

  const onClose = () => {
    navigate(route.fullPath({ id }))
  }

  return <RenameAutomationModal automationId={id} onClose={onClose} />
}

export default RenameAutomationModalPage
